<template>
  <v-container>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <h2>
      List Log Transaksi
    </h2>

    <v-text-field
      class="mt-3"
      label="Search No Order"
      outlined
      dense
      :rules="[v => !!v || 'No Order wajib diisi']"
      v-model="search"
      @keyup.enter="
        if (search) {
          GetDetailTransaksi();
        }
      "
    ></v-text-field>

    <v-row>
      <v-col cols="12" md="12">
        <v-card
          outlined
          v-if="LogTransaksi && LogTransaksi.length != 0"
          class="mx-auto"
          max-width="800"
        >
          <v-container>
            <v-toolbar flat>
              <h3>Log Transaksi</h3>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list-item-group
              class="px-2 py-2"
              style="max-height: 400px; overflow:auto; "
            >
              <v-list-item
                v-for="item in LogTransaksi"
                :key="item.id"
                style="border-bottom: 1px solid grey;"
              >
                <template v-slot:default="{}">
                  <v-list-item-content>
                    <v-list-item-title v-if="item.updated_by_type == 3"
                      ><span style="color: #c90000"
                        >{{ item.updated_by_type_nama }}
                      </span>
                      - {{ item.created_at | dateTimeFormat3 }}
                    </v-list-item-title>

                    <v-list-item-title v-if="item.updated_by_type == 1"
                      ><span style="color: #9c27b0">{{
                        item.updated_by_type_nama
                      }}</span>
                      - {{ item.created_at | dateTimeFormat3 }}
                    </v-list-item-title>
                    <v-list-item-title v-if="item.updated_by_type == 2"
                      ><span style="color: #ffc107">{{
                        item.updated_by_type_nama
                      }}</span>
                      -
                      {{ item.created_at | dateTimeFormat3 }}
                    </v-list-item-title>
                    <v-list-item-title v-if="item.updated_by_type == 4"
                      ><span style="color: #37474f">{{
                        item.updated_by_type_nama
                      }}</span>
                      -
                      {{ item.created_at | dateTimeFormat3 }}
                    </v-list-item-title>

                    <v-list-item-subtitle
                      v-if="item.pembayaran_status"
                      class="text--primary"
                    >
                      Status :
                      <b>
                        <b>{{ item.pembayaran_status }}</b>
                      </b></v-list-item-subtitle
                    >
                    <v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.pembayaran_note">
                        Note :
                        <b>{{ item.pembayaran_note }}</b></v-list-item-subtitle
                      >
                      <v-list-item-subtitle v-if="item.note_detail">
                        Note Detail :
                        <b>{{ item.note_detail }}</b></v-list-item-subtitle
                      >
                    </v-list-item-subtitle>
                    <span style="color: grey;"
                      ><b>{{ item.aktivitas }}</b></span
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-title>
                      {{ item.created_at | dateTimeFormat2 }} WIB
                    </v-list-item-title>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-container>
        </v-card>
      </v-col>
      <v-col
        v-if="TransaksiDetail && TransaksiDetail.length != 0"
        cols="12"
        md="12"
      >
        <v-card>
          <v-container>
            <h2>Transaksi</h2>
            <v-row>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Order Type</v-list-item-title>
                  <v-list-item-subtitle
                    ><b
                      ><b>{{ TransaksiDetail.type }}</b></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Order Jenis Iklan</v-list-item-title>
                  <v-list-item-subtitle
                    ><b
                      ><b>{{ TransaksiDetail.jenis_iklan }}</b></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Created At</v-list-item-title>
                  <v-list-item-subtitle
                    ><b
                      ><b>{{
                        TransaksiDetail.created_at | dateTimeFormat
                      }}</b></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Expired At</v-list-item-title>
                  <v-list-item-subtitle
                    ><b v-if="TransaksiDetail.expired_at">{{
                      TransaksiDetail.expired_at | dateTimeFormat
                    }}</b>
                    <b v-else>-</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
            </v-row>
            <v-divider light></v-divider>
            <v-row>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Nama Pembeli</v-list-item-title>
                  <v-list-item-subtitle
                    ><b
                      ><b>{{ TransaksiDetail.nama_pembeli }}</b></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Type Pembeli</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.type_user_pembeli }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Nama Penjual</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.nama_penjual }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Type Penjual</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.type_user_penjual }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>No order</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.no_order }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Order Status</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.order_status }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>pembayaran status</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.pembayaran_status }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Metode Pembayaran</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.metode }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>

              <v-col cols="12" md="3" v-if="TransaksiDetail.note">
                <v-list-item-content>
                  <v-list-item-title>Note</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.note }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3" v-if="TransaksiDetail.note_detail">
                <v-list-item-content>
                  <v-list-item-title>Note Detail</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.note_detail }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
            </v-row>
            <v-divider light></v-divider>
            <v-row>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Jumlah</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>{{ TransaksiDetail.jumlah }}</b>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3" v-if="TransaksiDetail.harga">
                <v-list-item-content>
                  <v-list-item-title>Harga</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>
                      <span style="color:red"
                        >Rp {{ TransaksiDetail.harga }}</span
                      ></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3" v-if="TransaksiDetail.subtotal">
                <v-list-item-content>
                  <v-list-item-title>Subtotal</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>
                      <span style="color:red"
                        >Rp {{ TransaksiDetail.subtotal }}</span
                      ></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>Total Pembayaran</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>
                      <span style="color:red"
                        >Rp {{ TransaksiDetail.total_pembayaran }}</span
                      ></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
            </v-row>
            <v-divider light></v-divider>
            <v-row>
              <v-col cols="12" md="3">
                <v-list-item-content>
                  <v-list-item-title>ID iklan</v-list-item-title>
                  <v-list-item-subtitle
                    ><b>
                      <span> {{ TransaksiDetail.id_iklan }}</span></b
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
            </v-row>
            <v-row v-if="TransaksiDetail.pencairan_tiket">
              <v-list dense>
                <v-header>Daftar Tiket</v-header>
                <v-list-item-group color="primary">
                  <v-list-item v-for="item in ListTiket" :key="item.id">
                    <v-list-item-content>
                      <v-list-item-subtitle
                        ><b>{{ item.count }}</b> Tiket x Rp
                        <b>{{ item.harga }}</b></v-list-item-subtitle
                      >
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-list-item-subtitle>
                        <span style="color:red"
                          >Rp <b>{{ item.total }}</b></span
                        >
                      </v-list-item-subtitle>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card v-if="ReqTransaksi">
                  <div class="d-flex flex-no-wrap ">
                    <v-avatar size="125" tile>
                      <v-img
                        :src="$url_img + TransaksiDetail.iklan.photo"
                      ></v-img>
                    </v-avatar>
                    <div>
                      <v-card-title
                        class="headline"
                        v-text="TransaksiDetail.iklan.judul"
                      ></v-card-title>
                      <v-card-subtitle v-if="TransaksiDetail.iklan.harga_tiket"
                        >Harga :
                        <span style="color:red"
                          ><b>
                            Rp <b>{{ TransaksiDetail.iklan.harga_tiket }}</b></b
                          ></span
                        ></v-card-subtitle
                      >
                      <v-card-subtitle v-if="TransaksiDetail.iklan.kelipatan"
                        >Kelipatan
                        <span style="color:red"
                          ><b>
                            Rp
                            <b>{{ TransaksiDetail.iklan.kelipatan }}</b></b
                          ></span
                        ></v-card-subtitle
                      >
                      <v-card-subtitle
                        v-text="TransaksiDetail.iklan.deskripsi"
                      ></v-card-subtitle>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment-timezone';

export default {
  data: () => ({
    selected: [2],
    color: { snackbar: '' },
    snackbar: false,
    message: null,

    LogTransaksi: null,
    itemsPerPage: 999,
    search: null,
    bidder: [],
    IklanSatuan: false,
    ReqTransaksi: [],
    fotos: [],
    utc: moment().utcOffset() / 60 - 7,
    waktu: '',
    appuser: [],
    IklanPaketan: false,
    motorBekas: []
  }),
  methods: {
    async GetDetailTransaksi() {
      this.TransaksiDetail = [];
      this.LogTransaksi = [];
      if (this.search) {
        await this.$req
          .get(this.$root.$baseapi.transaksi+'/transaksi/v4/order', {
            params: {
              limit: 1,
              no_order: this.search
            }
          })
          .then(response => {
            this.ReqTransaksi = response.data.data[0];
          })
          .catch(error => {
            let responses = error.response.data;
            console.log(responses.api_message);
          });
      }
      if (this.ReqTransaksi) {
        this.GetLogTransaksi(this.ReqTransaksi.id);
      }
    },

    async GetLogTransaksi() {
      await this.$req
        .get(this.$root.$baseapi.log+'/log/v3/log/transaksi', {
          params: {
            no_order: this.search,
            limit: 1000
          }
        })
        .then(response => {
          this.LogTransaksi = response.data.data;
        })
        .catch(error => {
          let responses = error.response.data;
          this.snackbar = true;
          this.color.snackbar = 'red';
          this.message = responses.api_message;
        });
      // let ayam = [];
    }
  },

  computed: {
    TransaksiDetail: {
      get: function() {
        return this.ReqTransaksi;
      },
      set: function(a) {
        this.ReqTransaksi = a;
      }
    },
    ListTiket() {
      var ret = [];
      for (let i in this.ReqTransaksi.pencairan_tiket) {
        let key = this.ReqTransaksi.pencairan_tiket[i].harga_beli;
        let count = ret[key] && ret[key].count ? ret[key].count + 1 : 1;
        ret[key] = {
          harga: key,
          count: count,
          total: key * count
        };
      }
      return Object.values(ret);
    }
  },

  created() {
    // this.GetDetailTransaksi();
    if (this.utc == 0) {
      this.waktu = 'WIB';
    }
    if (this.utc == 1) {
      this.waktu = 'WITA';
    }
    if (this.utc == 2) {
      this.waktu = 'WIT';
    }
  },
  filters: {
    dateTimeFormat: (date, utc) => {
      return moment
        .utc(date)
        .add(utc, 'h')
        .format('DD MMM YYYY HH:mm');
    },

    dateTimeFormat2: (date, utc) => {
      return moment
        .utc(date)
        .add(utc, 'h')
        .format('HH:mm');
    },
    dateTimeFormat3: (date, utc) => {
      return moment
        .utc(date)
        .add(utc, 'h')
        .format('DD MMM YYYY');
    },
    datediff: date => {
      return moment(date).from();
    }
  }
};
</script>
